import React, { useRef, useState, useEffect } from 'react';

// B10 — solution videos should be speed-adjustable up to 3x. The native <video>
// element supports any playbackRate, but the browser's built-in speed menu tops
// out at 2x, so we render our own 1x–3x pills that drive `video.playbackRate`.
const SPEEDS = [0.25, 0.5, 1, 1.5, 2, 3];

interface Props {
  src: string;
  /** className passed straight to the <video> element */
  className?: string;
  /** className for the wrapping div (defaults to full width) */
  wrapperClassName?: string;
  /** start playing as soon as it loads */
  autoPlay?: boolean;
}

export default function VideoWithSpeed({ src, className, wrapperClassName, autoPlay }: Props) {
  const ref = useRef<HTMLVideoElement>(null);
  const [rate, setRate] = useState(1);

  // Browsers reset playbackRate to 1 whenever new media loads, so re-apply the
  // chosen rate on rate/src change (and on loadedmetadata below).
  useEffect(() => {
    if (ref.current) ref.current.playbackRate = rate;
  }, [rate, src]);

  // YouTube-vari gövdeye tıklayınca oynat/durdur. Alt ~48px native kontrol
  // şeridine ait — oradaki tıklamayı es geçiyoruz, yoksa kontroldeki play
  // butonu + bizim toggle aynı anda tetiklenip video hiç oynamıyor gibi
  // görünüyor.
  const togglePlay = (e: React.MouseEvent<HTMLVideoElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    if (rect.bottom - e.clientY <= 48) return;
    const v = e.currentTarget;
    if (v.paused) void v.play();
    else v.pause();
  };

  return (
    <div className={wrapperClassName ?? 'w-full'}>
      {/* max-h + object-contain: dikey (9:16) videolar ekrandan taşmak yerine
          kutu içinde letterbox'lanır — boyut/oryantasyon şikayetinin fix'i. */}
      <video
        ref={ref}
        key={src}
        src={src}
        autoPlay={autoPlay}
        controls
        controlsList="nodownload noremoteplayback"
        disablePictureInPicture
        onContextMenu={(e) => e.preventDefault()}
        onClick={togglePlay}
        onLoadedMetadata={() => { if (ref.current) ref.current.playbackRate = rate; }}
        className={`speedvideo max-h-[78vh] object-contain ${className ?? ''}`}
      />
      <div className="flex items-center justify-center gap-1 mt-2">
        {SPEEDS.map((s) => (
          <button
            key={s}
            type="button"
            onClick={() => setRate(s)}
            className={`px-2.5 py-1 rounded-full text-[12px] font-semibold transition-colors ${
              rate === s
                ? 'bg-[#3973bf] text-white'
                : 'bg-white/90 text-[#2b2b2b] border border-gray-200 hover:bg-gray-100'
            }`}
          >
            {s % 1 === 0 ? s : s.toFixed(2).replace(/0$/, '')}x
          </button>
        ))}
      </div>
    </div>
  );
}
